<template>
  <div class="freemium-banner pa-4">
    <p class="freemium-banner__title text--small font-weight-bold mb-1">
      {{ $t(`${TRANSLATION_KEY_PREFIX}.remainingConversations`, { count: remainingConversations ?? 0 }, remainingConversations ?? 0) }}
    </p>
    <p class="freemium-banner__subtitle text--x-small mb-3">
      {{ $t(`${TRANSLATION_KEY_PREFIX}.upgradeDescription`) }}
    </p>
    <app-button
      class="freemium-banner__cta"
      data-locator="freemium-upgrade-button"
      @click="$emit('upgrade')"
    >
      {{ $t(`${TRANSLATION_KEY_PREFIX}.upgradeButton`) }}
    </app-button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

const TRANSLATION_KEY_PREFIX = 'common.ai-assistant.AIAssistantFreemiumBanner'

export default defineComponent({
  name: 'AIAssistantFreemiumBanner',
  emits: ['upgrade'],
  props: {
    remainingConversations: {
      type: Number as () => number | null,
      default: null,
    },
  },
  data() {
    return {
      TRANSLATION_KEY_PREFIX,
    }
  },
})
</script>

<style scoped lang="scss">
.freemium-banner {
  background-color: #F7F9FA;
  border-radius: 8px;
  margin: 0 12px 12px;

  &__title {
    color: #00172E;
  }

  &__subtitle {
    color: #2A476A;
  }

  &__cta {
    background-color: #00172E !important;
    font-size: 14px !important;
    font-weight: 700 !important;
  }
}
</style>
